import Vue from 'vue';
import App from './App.vue';
import router from './util/router.js';
import store from './util/store.js'
import vuetify from './plugins/vuetify.js';
import './registerServiceWorker';

var dataLayer = dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', 'UA-139532498-1');

new Vue({
  vuetify,
  store,
  render: h => h(App),
  router
}).$mount('#app');